/* After Dark Attire – Shopify theme script */
(function () {
  'use strict';
  var T = window.theme || {};
  var S = T.strings || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (x) {
    return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount}}';
    function fmt(n, p, t, d) {
      p = p == null ? 2 : p; t = t || ','; d = d || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(p);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/), v = '';
    switch (m && m[1]) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' '); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = fmt(cents, 2, ' ', '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- layers / toast ---------- */
  var ov = $('#ov');
  function layer(on) { if (ov) ov.classList.toggle('on', on); }
  function closeAll() {
    $$('.drawer,.modal,.sr').forEach(function (e) { e.classList.remove('on'); });
    layer(false);
  }
  function toast(t) {
    var e = $('#toast'); if (!e) return;
    e.textContent = t; e.classList.add('on');
    clearTimeout(toast.h); toast.h = setTimeout(function () { e.classList.remove('on'); }, 2200);
  }
  if (ov) ov.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); setMenu(false); var dd = $('#dd'); if (dd) dd.hidden = true; } });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]')) closeAll();
  });

  /* Move page-level dialogs to <body> so the overlay can sit behind them */
  $$('[data-portal]').forEach(function (el) { document.body.appendChild(el); });

  /* ---------- JSON helpers ---------- */
  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status); return r.json();
    });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function imgUrl(src, w) {
    if (!src) return '';
    return src.replace(/(\.(jpe?g|png|gif|webp))(\?|$)/i, '_' + w + 'x$1$3');
  }

  /* ---------- cart ---------- */
  var cartState = null;
  function setCount(n) { $$('[data-cart-count]').forEach(function (e) { e.textContent = n; }); }
  function loadCart() { return getJSON(T.routes.cartJson + '?t=' + Date.now()).then(function (c) { cartState = c; setCount(c.item_count); return c; }); }

  /* ---------- voucher / discount code (validated and applied by Shopify at checkout) ---------- */
  function getVoucher() { try { return sessionStorage.getItem('ada_voucher') || ''; } catch (e) { return ''; } }
  function setVoucher(v) { try { if (v) sessionStorage.setItem('ada_voucher', v); else sessionStorage.removeItem('ada_voucher'); } catch (e) { } }
  function voucherHtml() {
    var v = getVoucher();
    return '<div class="vf">' + (v
      ? '<span>Voucher · ' + esc(v) + '</span><button class="btn ghost" type="button" data-voucher-remove>Remove</button>'
      : '<input type="text" data-voucher-code placeholder="Voucher code" maxlength="40" aria-label="Voucher code" autocomplete="off"><button class="btn ghost" type="button" data-voucher-apply>Apply</button>') +
      '</div><p class="err" data-voucher-msg>' + (v ? 'Your code will be applied at checkout.' : '') + '</p>';
  }
  function paintVoucherBoxes() {
    var v = getVoucher();
    $$('[data-voucher-box]').forEach(function (b) { b.innerHTML = voucherHtml(); });
    $$('[data-voucher-input]').forEach(function (i) { i.value = v; });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-voucher-apply]'), r = e.target.closest('[data-voucher-remove]');
    if (a) {
      var wrap = a.parentNode, inp = wrap.querySelector('[data-voucher-code]');
      var code = (inp.value || '').trim().toUpperCase().replace(/[^A-Z0-9_\-]/g, '');
      if (!code) { var m = wrap.parentNode.querySelector('[data-voucher-msg]'); if (m) m.textContent = 'Enter a voucher code.'; return; }
      setVoucher(code); toast('Voucher saved: ' + code);
      if (cartState) drawCart(cartState);
      paintVoucherBoxes();
    } else if (r) {
      setVoucher('');
      if (cartState) drawCart(cartState);
      paintVoucherBoxes();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-voucher-code]')) {
      e.preventDefault(); var b = e.target.parentNode.querySelector('[data-voucher-apply]'); if (b) b.click();
    }
  });
  paintVoucherBoxes();

  function drawCart(c) {
    var db = $('#db'), df = $('#df'); if (!db) return;
    if (!c.items.length) {
      db.innerHTML = '<p class="empty">' + esc(S.emptyBag) + '</p>'; df.innerHTML = ''; return;
    }
    db.innerHTML = c.items.map(function (i) {
      var note = i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '';
      var isReady = i.properties && i.properties._dispatch === 'ready';
      var tagNote = isReady ? T.readyShort : T.cardNote;
      if (tagNote) note += (note ? ' · ' : '') + esc(tagNote);
      return '<div class="li"><div class="th"><a href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(imgUrl(i.image, 200)) + '" alt="' + esc(i.product_title) + '">' : '') + '</a></div>' +
        '<div><strong><a href="' + esc(i.url) + '">' + esc(i.product_title) + '</a></strong><div style="color:var(--mute);font-size:14px">' + note + '</div>' +
        '<div class="q"><button type="button" data-cm="' + esc(i.key) + '" data-d="-1" aria-label="Decrease">−</button><span>' + i.quantity + '</span><button type="button" data-cm="' + esc(i.key) + '" data-d="1" aria-label="Increase">+</button></div></div>' +
        '<div style="text-align:right">' + formatMoney(i.final_line_price) + '<br><button class="lnk" type="button" data-cm="' + esc(i.key) + '" data-d="-999">' + esc('Remove') + '</button></div></div>';
    }).join('');
    var disc = '';
    (c.cart_level_discount_applications || []).forEach(function (d) {
      disc += '<div class="tot" style="color:var(--rose)"><span>' + esc(d.title) + '</span><span>−' + formatMoney(d.total_allocated_amount) + '</span></div>';
    });
    var baseLine = '';
    if (T.base && +T.base.rate) baseLine = '<div class="tot"><span>Approx. in ' + esc(T.base.code) + ' (base currency)</span><span>' + esc(T.base.symbol) + (c.total_price * T.base.rate / 100).toFixed(2) + '</span></div>';
    df.innerHTML = disc + '<div class="tot big"><span>Subtotal</span><span>' + formatMoney(c.total_price) + '</span></div>' + baseLine +
      voucherHtml() +
      '<p class="discount-note" style="margin:0">Shipping and taxes are calculated at checkout.</p>' +
      '<a class="btn" href="' + esc(T.routes.cart) + '" style="background:none;border:1px solid var(--ink);color:var(--ink)">View bag</a>' +
      '<form action="' + esc(T.routes.cart) + '" method="post">' + (getVoucher() ? '<input type="hidden" name="discount" value="' + esc(getVoucher()) + '">' : '') + '<button class="btn" type="submit" name="checkout" style="width:100%;border:0">Checkout</button></form>';
  }
  function openCart() {
    closeAll();
    return loadCart().then(function (c) { drawCart(c); $('#drawer').classList.add('on'); layer(true); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cm]'); if (!b) return;
    var key = b.getAttribute('data-cm'), d = +b.getAttribute('data-d');
    var line = (cartState && cartState.items || []).filter(function (i) { return i.key === key; })[0]; if (!line) return;
    postJSON(T.routes.cartChange + '.js', { id: key, quantity: Math.max(0, line.quantity + d) })
      .then(function (c) { cartState = c; setCount(c.item_count); drawCart(c); }).catch(function () {});
  });
  var cbtn = $('#cbtn');
  if (cbtn) cbtn.addEventListener('click', function (e) {
    if (document.body.classList.contains('template-cart')) return;
    e.preventDefault(); openCart();
  });
  function addToCart(variantId, qty, title, props) {
    var item = { id: +variantId, quantity: qty || 1 };
    if (props) item.properties = props;
    return postJSON(T.routes.cartAdd + '.js', { items: [item] }).then(function () {
      toast((S.added || '').replace('__TITLE__', title || ''));
      return openCart();
    });
  }

  /* cart page quantity buttons */
  $$('[data-qty-change]').forEach(function (b) {
    b.addEventListener('click', function () {
      var inp = $('[data-line-qty="' + b.getAttribute('data-qty-change') + '"]');
      inp.value = Math.max(0, (+inp.value || 0) + (+b.getAttribute('data-delta')));
      var f = $('#cart-form'); if (f) { var u = document.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = '1'; f.appendChild(u); f.submit(); }
    });
  });

  /* ---------- wishlist (stored in the browser) ---------- */
  var wl = [];
  try { wl = JSON.parse(localStorage.getItem('ada_wl') || '[]'); } catch (e) { }
  function saveWl() { try { localStorage.setItem('ada_wl', JSON.stringify(wl)); } catch (e) { } }
  function paintWl() {
    $$('[data-wishlist-count]').forEach(function (e) { e.textContent = wl.length; });
    $$('[data-wl]').forEach(function (b) {
      var on = wl.indexOf(b.getAttribute('data-wl')) > -1;
      b.classList.toggle('on', on); b.innerHTML = on ? '&#9829;' : '&#9825;';
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wl]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-wl'), i = wl.indexOf(h);
    if (i > -1) { wl.splice(i, 1); toast(S.removed); } else { wl.push(h); toast(S.saved); }
    saveWl(); paintWl();
    if ($('#wdrawer').classList.contains('on')) drawWl();
  });
  function drawWl() {
    var box = $('#wdb');
    if (!wl.length) { box.innerHTML = '<p class="empty">' + esc(S.wishlistEmpty) + '</p>'; return; }
    box.innerHTML = '<p class="empty">…</p>';
    Promise.all(wl.map(function (h) { return getJSON('/products/' + encodeURIComponent(h) + '.js').catch(function () { return null; }); })).then(function (ps) {
      ps = ps.filter(Boolean);
      box.innerHTML = ps.map(function (p) {
        return '<div class="li"><div class="th"><a href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 200)) + '" alt="">' : '') + '</a></div>' +
          '<div><strong><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></strong><div style="color:var(--mute);font-size:14px">' + formatMoney(p.price) + '</div></div>' +
          '<div style="text-align:right"><button class="lnk" type="button" data-wl="' + esc(p.handle) + '">Remove</button></div></div>';
      }).join('') || '<p class="empty">' + esc(S.wishlistEmpty) + '</p>';
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-open-wishlist]')) return;
    e.preventDefault(); closeAll(); drawWl(); $('#wdrawer').classList.add('on'); layer(true);
  });
  paintWl();

  /* ---------- quick view ---------- */
  /* Size finder uses the size chart (inches): picks the larger of the bust and hip sizes */
  var BUST_MAX = [31.5, 34, 38, 42, 47, 52.5], HIP_MAX = [33.5, 36, 40, 44.5, 49, 55], SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  var idxOf = function (v, max) { for (var i = 0; i < max.length; i++) { if (v <= max[i]) return i; } return max.length; };
  var SZ_THRESH = function (b, h) { return SIZES[Math.max(idxOf(b, BUST_MAX), idxOf(h, HIP_MAX))]; };
  function sizeFinderHandler(onSuggest) {
    var fs = $('#fs'); if (!fs) return;
    fs.addEventListener('click', function () {
      var b = +$('#bu').value, h = +$('#hp').value, out = $('#fr');
      if (b && h) { var s = SZ_THRESH(b, h); out.textContent = (S.suggested || 'Suggested size:') + ' ' + s; if (onSuggest) onSuggest(s); }
      else out.textContent = S.findSize;
    });
  }
  function findVariant(p, sel) {
    return p.variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); })[0];
  }
  function openQuick(handle) {
    getJSON('/products/' + encodeURIComponent(handle) + '.js').then(function (p) {
      var sel = (p.options.length === 1 && p.variants.length === 1) ? [p.variants[0].option1] : p.options.map(function () { return null; });
      var gi = 0, imgs = p.images.length ? p.images : [];
      var simple = p.variants.length === 1;
      var isReadyP = !!T.readyTag && (p.tags || []).indexOf(T.readyTag) > -1;
      var draw = function () {
        var v = simple ? p.variants[0] : (sel.every(Boolean) ? findVariant(p, sel) : null);
        var ok = v && v.available;
        var label = !v ? S.selectSize : (ok ? S.addToBag : S.soldOut);
        $('#modal').innerHTML =
          '<div class="pi">' + (imgs[gi] ? '<img src="' + esc(imgUrl(imgs[gi], 900)) + '" alt="' + esc(p.title) + '">' : '') +
          '<div class="thumbs">' + (imgs.length < 2 ? '' : imgs.map(function (im, i) { return '<button type="button" class="' + (i === gi ? 'on' : '') + '" data-gi="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(imgUrl(im, 120)) + '" alt=""></button>'; }).join('')) + '</div></div>' +
          '<div class="pd"><button class="x" data-close type="button" aria-label="Close">×</button><h2>' + esc(p.title) + '</h2><div>' + formatMoney(v ? v.price : p.price) + '</div>' +
          (isReadyP ? '<p class="ready-note"><strong>' + esc(T.readyNote) + '</strong></p>' : (T.cardNote ? '<p class="mto-note"><strong>' + esc(T.cardNote) + '</strong></p>' : '')) +
          (simple ? '' : p.options.map(function (o, oi) {
            return '<div>' + esc(o.name) + '<div class="opt">' + o.values.map(function (val) {
              var any = p.variants.some(function (x) { return x['option' + (oi + 1)] === val && x.available; });
              return '<button type="button" class="sz ' + (sel[oi] === val ? 'on' : '') + '" data-oi="' + oi + '" data-ov="' + esc(val) + '"' + (any ? '' : ' style="opacity:.4;text-decoration:line-through"') + '>' + esc(val) + '</button>';
            }).join('') + '</div></div>';
          }).join('')) +
          '<button class="btn" id="qadd" type="button"' + (ok ? '' : ' disabled') + '>' + esc(label) + '</button>' +
          '<a class="lnk" href="' + esc(p.url) + '">View full details</a></div>';
        $$('#modal [data-gi]').forEach(function (b) { b.onclick = function () { gi = +b.getAttribute('data-gi'); draw(); }; });
        $$('#modal [data-ov]').forEach(function (b) { b.onclick = function () { sel[+b.getAttribute('data-oi')] = b.getAttribute('data-ov'); draw(); }; });
        var add = $('#qadd'); if (add) add.onclick = function () { add.disabled = true; addToCart(v.id, 1, p.title, isReadyP ? { _dispatch: 'ready' } : null).catch(function (er) { add.disabled = false; toast((er && er.description) || 'Could not add to bag'); }); };
      };
      draw(); closeAll(); $('#modal').classList.add('on'); layer(true);
      /* closeAll removes content classes only; modal content already drawn */
    }).catch(function () { window.location.href = '/products/' + handle; });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick]'); if (!q) return;
    e.preventDefault(); e.stopPropagation(); openQuick(q.getAttribute('data-quick'));
  });

  /* ---------- search overlay ---------- */
  var sbtn = $('#sbtn'), si = $('#si'), sres = $('#sres'), stm;
  if (sbtn) sbtn.addEventListener('click', function () { closeAll(); $('#sr').classList.add('on'); layer(true); si.focus(); });
  if (si) si.addEventListener('input', function () {
    clearTimeout(stm);
    var q = si.value.trim();
    if (!q) { sres.innerHTML = ''; return; }
    stm = setTimeout(function () {
      getJSON(T.routes.suggest + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) {
          var ps = (r.resources && r.resources.results && r.resources.results.products) || [];
          sres.innerHTML = ps.length ? ps.map(function (p) {
            return '<a href="' + esc(p.url) + '"><span>' + (p.image ? '<img src="' + esc(imgUrl(p.image, 100)) + '" alt="">' : '') + esc(p.title) + '</span><span>' + formatMoney(parseFloat(p.price) * 100) + '</span></a>';
          }).join('') : '<p class="empty">' + esc(S.noMatches) + '</p>';
        }).catch(function () { });
    }, 200);
  });

  /* ---------- mobile menu ---------- */
  var hdr = $('#site-header'), mb = $('#mbtn');
  function setMenu(o) { if (!hdr || !mb) return; hdr.classList.toggle('mo', o); mb.setAttribute('aria-expanded', String(o)); }
  if (mb) mb.addEventListener('click', function () { setMenu(!hdr.classList.contains('mo')); });

  /* ---------- account dropdown ---------- */
  var abtn = $('#abtn'), dd = $('#dd');
  if (abtn && dd) {
    abtn.addEventListener('click', function (e) { e.stopPropagation(); dd.hidden = !dd.hidden; abtn.setAttribute('aria-expanded', String(!dd.hidden)); });
    document.addEventListener('click', function (e) { if (!e.target.closest('.ddw')) dd.hidden = true; });
  }

  /* ---------- country selector ---------- */
  var gbtn = $('#gbtn');
  if (gbtn) gbtn.addEventListener('click', function () { closeAll(); $('#dlg').classList.add('on'); layer(true); });

  /* ---------- filter dialog ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-open-filter]')) return;
    closeAll(); var f = $('#filter-dlg'); if (f) { f.classList.add('on'); layer(true); }
  });

  /* ---------- product page ---------- */
  var ps = $('[data-product-section]');
  if (ps) {
    var variants = JSON.parse($('[data-variants]', ps).textContent);
    var form = $('#product-form', ps), vid = $('[data-variant-id]', ps), addBtn = $('[data-add]', ps), errEl = $('[data-error]', ps), priceEl = $('[data-price]', ps);
    var groups = $$('.optgrp', ps);
    var sel = groups.map(function (g) { var on = $('.sz.on', g); return on ? on.getAttribute('data-opt-value') : null; });
    if (!groups.length) sel = [variants[0].option1];
    var current = function () { return variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] == null || sel[i] === o; }); })[0]; };
    var refresh = function () {
      groups.forEach(function (g, gi) {
        $$('.sz', g).forEach(function (b) {
          var val = b.getAttribute('data-opt-value');
          b.classList.toggle('on', sel[gi] === val);
          var avail = variants.some(function (v) { return v.options[gi] === val && v.available; });
          b.style.opacity = avail ? '' : '.4'; b.style.textDecoration = avail ? '' : 'line-through';
        });
      });
      var full = sel.every(function (s) { return s != null; });
      var v = full ? current() : null;
      if (v) {
        vid.value = v.id;
        priceEl.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '');
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? S.addToBag : S.soldOut;
        if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
        if (v.featured_image && v.featured_image.src) setMain(v.featured_image.src);
      } else {
        addBtn.disabled = false; addBtn.textContent = full ? S.soldOut : S.selectSize;
        if (full) addBtn.disabled = true;
      }
    };
    groups.forEach(function (g, gi) {
      $$('.sz', g).forEach(function (b) { b.addEventListener('click', function () { sel[gi] = b.getAttribute('data-opt-value'); errEl.textContent = ''; refresh(); }); });
    });
    /* With several variants and no ?variant= in the URL, make the shopper choose (e.g. a size) first */
    if (groups.length && variants.length > 1 && !new URLSearchParams(location.search).get('variant')) {
      sel = groups.map(function () { return null; });
    }
    refresh();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!sel.every(function (s) { return s != null; })) { errEl.textContent = S.selectSize; return; }
      addBtn.disabled = true;
      var title = $('h1', ps).textContent;
      var rdy = $('[data-ready]', ps);
      addToCart(vid.value, 1, title, rdy ? { _dispatch: 'ready' } : null).then(function () { addBtn.disabled = false; })
        .catch(function (er) { addBtn.disabled = false; errEl.textContent = (er && (er.description || er.message)) || ''; });
    });
    function setMain(src) {
      var im = $('[data-main-image] img', ps);
      if (im) im.src = imgUrl(src, 1200);
    }
    $$('[data-thumb]', ps).forEach(function (b) {
      b.addEventListener('click', function () {
        var im = $('[data-main-image] img', ps); if (im) im.src = b.getAttribute('data-thumb');
        $$('[data-thumb]', ps).forEach(function (x) { x.classList.toggle('on', x === b); });
      });
    });
    sizeFinderHandler(function (size) {
      var name = (T.sizeOption || 'Size').toLowerCase();
      var opts = JSON.parse($('[data-options]', ps).textContent);
      var gi = opts.map(function (o) { return o.toLowerCase(); }).indexOf(name);
      if (gi < 0) gi = 0;
      var btn = $$('.sz', groups[gi] || document.createElement('div')).filter(function (b) { return [size, size === 'XXL' ? '2XL' : size].indexOf(b.getAttribute('data-opt-value').toUpperCase()) > -1; })[0];
      if (btn) btn.click();
    });
  }

  /* ---------- hero slider ---------- */
  var hero = $('[data-hero]');
  if (hero) {
    var imgs = $$('[data-hero-bg] img', hero), dots = $$('[data-hero-dots] button', hero), k = 0, tm;
    if (imgs.length > 1) {
      var show = function (n) {
        k = (n + imgs.length) % imgs.length;
        imgs.forEach(function (e, j) { e.classList.toggle('on', j === k); });
        dots.forEach(function (e, j) { if (j === k) e.setAttribute('aria-current', 'true'); else e.removeAttribute('aria-current'); });
      };
      var play = function () {
        clearInterval(tm);
        if (!matchMedia('(prefers-reduced-motion:reduce)').matches) tm = setInterval(function () { show(k + 1); }, 5500);
      };
      dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); play(); }); });
      play();
    }
  }

  /* ---------- social feed marquee ---------- */
  var tk = $('#fdt'), fv = $('#fdv');
  if (tk && fv && tk.children.length) {
    var vp = function () { $$('#fdt video').forEach(function (v) { v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); var p = v.play(); if (p && p.catch) p.catch(function () { }); }); };
    tk.addEventListener('loadeddata', function (e) { if (e.target.tagName === 'VIDEO') vp(); }, true);
    vp();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) vp(); });
    addEventListener('pointerdown', vp, { once: true });
    var N = +tk.getAttribute('data-count') || tk.children.length, x = 0, w = 0, last = 0, hold = false, SP = 55;
    var duplicated = tk.children.length >= N * 2;
    var meas = function () {
      if (!duplicated) return;
      var nw = tk.children[N].offsetLeft - tk.children[0].offsetLeft;
      if (nw > 0) { x = w ? x / w * nw : 0; w = nw; }
    };
    if (!duplicated || matchMedia('(prefers-reduced-motion:reduce)').matches) { fv.style.overflowX = 'auto'; }
    else {
      var tick = function (t) {
        var dt = Math.min(t - last, 64) / 1000; last = t;
        if (!hold && !document.hidden && w) { x += SP * dt; if (x >= w) x -= w; tk.style.transform = 'translateX(' + (-x) + 'px)'; }
        requestAnimationFrame(tick);
      };
      meas(); addEventListener('resize', meas); addEventListener('load', meas);
      fv.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold = true; });
      fv.addEventListener('pointerleave', function () { hold = false; });
      fv.addEventListener('focusin', function () { hold = true; });
      fv.addEventListener('focusout', function () { hold = false; });
      requestAnimationFrame(function (t) { last = t; tick(t); });
    }
  }

  /* ---------- sparkle background ---------- */
  var sky = $('#sky');
  if (sky) {
    var n = innerWidth < 700 ? 46 : 96, r = function (a, b) { return a + Math.random() * (b - a); }, C = ['#ff2f9f', '#ff5db1', '#ff8cc8', '#ffc2e2'];
    var halo = function (c) { return "<defs><radialGradient id='g'><stop offset='.2' stop-color='" + c + "' stop-opacity='.6'/><stop offset='1' stop-color='" + c + "' stop-opacity='0'/></radialGradient></defs><circle cx='12' cy='12' r='12' fill='url(#g)'/>"; };
    var uri = function (b) { return 'url("data:image/svg+xml,' + encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>" + b + '</svg>') + '")'; };
    var S5 = C.map(function (c) { return uri(halo(c) + "<path fill='" + c + "' d='M12 4l2.3 5 5.5.6-4.1 3.7 1.2 5.4L12 15.9 7.1 18.7l1.2-5.4L4.2 9.6l5.5-.6z'/>"); });
    var S4 = C.map(function (c) { return uri(halo(c) + "<path fill='" + c + "' d='M12 2c.8 5.6 4.4 9.2 10 10-5.6.8-9.2 4.4-10 10-.8-5.6-4.4-9.2-10-10 5.6-.8 9.2-4.4 10-10z'/>"); });
    for (var q = 0; q < n; q++) {
      var t = q % 3, i = document.createElement('i'), z = t ? r(t === 1 ? 10 : 8, t === 1 ? 22 : 16) : r(2, 4), c = Math.floor(r(0, 4));
      if (!t) i.className = 'g'; else i.style.backgroundImage = (t === 1 ? S5 : S4)[c];
      i.style.cssText += 'left:' + r(0, 98).toFixed(1) + '%;top:' + r(0, 98).toFixed(1) + '%;width:' + z.toFixed(1) + 'px;height:' + z.toFixed(1) + 'px;--d:' + r(2.2, 5.5).toFixed(1) + 's;--l:-' + r(0, 6).toFixed(1) + 's;--r:' + Math.round(r(0, 40)) + 'deg';
      sky.appendChild(i);
    }
  }

  /* ---------- auto-switch to AED for visitors in the UAE (once per browser) ---------- */
  try {
    var gf = $('#geo-form'), tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (gf && T.geo && T.geo.hasAE && T.geo.current !== 'AE' && tz === 'Asia/Dubai' && !localStorage.getItem('ada_geo')) {
      localStorage.setItem('ada_geo', '1'); gf.submit();
    }
  } catch (e) { }

  /* ---------- keep cart count fresh (back/forward cache) ---------- */
  addEventListener('pageshow', function (e) { if (e.persisted) loadCart().catch(function () { }); });
})();
